export default __webpack_public_path__ + "./images/gw.5214e02d.png";